<template>
    <div>
        <v-form ref="formData" class="form-data" @submit.prevent="onSubmit()" style="user-select: none">
            <v-app-bar flat color="white" height="72" fixed app>
                <!-- Start Navigation Back to User Access - Roles Tab-->
                <router-link to="/user-access#roles" style="text-decoration: none; color: inherit">
                    <v-icon left x-large class="pa-4"> mdi-arrow-left </v-icon>
                </router-link>
                <!-- End Navigation Back to User Access - Roles Tab-->

                <!-- Start Upper Left Label -->
                <h2 class="d-flex align-center">
                    <span v-if="action == 'add'">Add Role</span>
                    <span v-if="action == 'edit'">Edit Role</span>
                    <span v-if="action == 'view'">{{ form.name }} </span>
                </h2>
                <small :class="['mx-4 px-2 py-1 px-4 font-weight-medium status', form.status.toLowerCase()]" v-if="isView">
                    {{ form.status | uppercaseFirst }}
                </small>
                <!-- End Upper Left Label -->

                <!-- Start Upper Right Btns -->
                <v-card flat class="ml-auto">
                    <v-btn class="mx-1" @click="editDetails()" outlined text v-if="isView">
                        <v-icon small>mdi-square-edit-outline</v-icon>
                        Edit Role
                    </v-btn>
                    <v-btn class="mx-1" @click="cancelAction()" outlined text v-else>Cancel</v-btn>
                    <v-btn type="submit" color="primary" :loading="form.loading" :class="['mx-1', { disabled: isView }]"> Save</v-btn>
                </v-card>
                <!-- End Upper Right Btns -->
            </v-app-bar>

            <v-container fluid class="pa-6">
                <v-row class="pl-4 pt-4">
                    <v-col cols="12" md="7" class="pt-8 pb-0">
                        <!-- Start View Role -->
                        <div class="card px-8 pt-5 pb-6 white rounded-lg" v-if="isView">
                            <h3 class="mb-4 page-section-title">Role Detail</h3>
                            <v-row>
                                <v-col cols="12" md="6" class="form-detail">
                                    <div>Name</div>
                                    <div>{{ form.name }}</div>
                                </v-col>

                                <v-col cols="12" md="12" class="form-detail">
                                    <div>Description</div>
                                    <div>{{ form.description }}</div>
                                </v-col>
                            </v-row>
                        </div>
                        <!-- End View Role -->

                        <!-- Start Add/Edit Role -->
                        <div v-else>
                            <h3 class="mb-4 page-section-title">Role Detail</h3>

                            <label for="name" class="font-weight-medium">Name</label>
                            <v-text-field :class="['mt-3 ma-0 pa-0', { 'is-invalid': errors.name }]" :error-messages="errors.name" v-model="form.name" placeholder="Enter Name" solo dense></v-text-field>

                            <label for="description" class="font-weight-medium">Description</label>
                            <v-textarea :class="['mt-3 ma-0 pa-0', { 'is-invalid': errors.description }]" :error-messages="errors.description" v-model="form.description" placeholder="Enter Description" solo dense>
                            </v-textarea>
                        </div>
                        <!-- End Add/Edit Role -->

                        <div :class="['card d-flex align-center my-4 px-8 py-5 white rounded-lg', { 'disabled-view': isView }]">
                            <v-row>
                                <v-col cols="8" class="font-weight-bold page-section-title">Status</v-col>
                                <v-col cols="4">
                                    <v-switch
                                        v-model="isRoleActive"
                                        :label="isRoleActive ? 'Active' : 'Inactive' | uppercaseFirst"
                                        color="success"
                                        :class="['float-right', { 'switch-status-active': isRoleActive }]"
                                        hide-details="auto"
                                        inset
                                    ></v-switch>
                                </v-col>
                            </v-row>
                        </div>

                        <!-- Start Show Delete for View/Edit User; -->
                        <div class="card d-flex align-center my-4 px-8 py-5 white rounded-lg" v-if="isView">
                            <span class="font-weight-bold page-section-title">Delete this Role</span>
                            <v-btn
                                color="error"
                                class="ml-auto float-right"
                                @click="
                                    confirmAction({
                                        action: 'delete',
                                        data: {
                                            id: $route.params.id
                                        }
                                    })
                                "
                                elevation="0"
                                >Delete</v-btn
                            >
                        </div>
                        <!-- EndShow Delete for View/Edit User -->
                    </v-col>
                    <v-col cols="12" md="5" class="pt-8 pb-0">
                        <!-- Start Right Side Permissions -->
                        <Permissions :role-id="roleId" page="roles" @setNewActionKeys="setNewActionKeys" @setNewModuleCount="setNewModuleCount" />
                        <!-- End Right Side Permissions -->
                    </v-col>
                </v-row>
            </v-container>
        </v-form>

        <AppModal :confirm-dialog="confirmDialog" :confirm-status-loading="confirmStatusLoading" @modalAction="modalAction" />
    </div>
</template>

<script>
import Permissions from '@/components/UserAccess/Permissions.vue';
import AppModal from '@/components/Core/AppModal.vue';

export default {
    name: 'RoleAction',
    components: {
        Permissions,
        AppModal
    },
    data() {
        return {
            action: '',
            from: '',
            form: {
                id: '',
                name: '',
                description: '',
                status: 'ACTIVE',
                loading: false
            },
            isView: false,
            roleId: '',
            isRoleActive: true,
            newActionKeys: [],
            newModuleCount: {},
            confirmDialog: { show: false, action: '', data: {}, status: '' },
            confirmStatusLoading: false
        };
    },
    computed: {
        roleDetails() {
            return this.$store.getters['roles/getRole'];
        }
    },
    // Determine page and API calls
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.from = from.name;
            vm.onLoadData(to);
        });
    },
    watch: {
        $route(to, from) {
            this.from = from.name;
            this.onLoadData(to, from);
        },

        roleDetails(role) {
            const form = {
                id: '',
                name: '',
                description: '',
                status: 'ACTIVE',
                loading: false
            };

            if (this.action != 'add') {
                this.form = { ...form, ...role };
                this.isRoleActive = this.form.status == 'ACTIVE' ? true : false;
            } else {
                this.form = form;
            }
        }
    },
    methods: {
        // Determine page and API calls
        onLoadData(to) {
            this.action = this.$route.params.action;
            this.roleId = this.$route.params.id;
            this.isView = false;

            switch (to.params.action) {
                case 'view':
                    this.isView = true;
                    break;
            }
        },
        // On Edit Role button click, enable editing of role details
        editDetails() {
            this.action = 'edit';
            this.$router.push(`/user-access/roles/edit/${this.$route.params.id}`);
        },
        // On Cancel button click, determine route
        // If edit is from view, load view UI; Otherwise redirect to user access - role datatable (Has issue w/ page refresh)
        cancelAction() {
            if (this.action == 'edit' /*&& this.from == 'roles-action'*/) {
                this.action = 'view';
                this.$router.push(`/user-access/roles/view/${this.$route.params.id}`);
            } else {
                this.$router.push({ name: 'user-access', hash: '#roles' });
            }
        },
        // Modal confirmation
        confirmAction({ action, data }) {
            switch (action) {
                case 'delete':
                    data.modalTitle = `Are you sure you want to delete role ${this.form.name}?`;
                    data.modalDescription = 'Deleting will remove this role and all the permission to this role.';
                    this.confirmDialog = { show: true, action, data };
                    break;
            }
        },
        // Exec modal action
        modalAction({ action, data }) {
            switch (action) {
                case 'delete':
                    this.form.confirmation = 1;
                    console.log(this.form, data);
                    this.deleteRole(data);
                    break;

                case 'cancel':
                    this.confirmDialog.show = false;
                    break;
            }
        },
        // Delete role
        deleteRole() {
            this.confirmStatusLoading = true;

            this.$store
                .dispatch('roles/deleteRole', {
                    id: this.$route.params.id,
                    config: {
                        params: { ...this.form }
                    }
                })
                .then((response) => {
                    this.confirmStatusLoading = false;
                    this.$router.push({ name: 'user-access', hash: '#roles' });
                    this.notification({ type: 'success', title: 'User Role', message: response.message });
                })
                .catch(() => {
                    this.confirmStatusLoading = false;
                });
        },
        // On form submit
        onSubmit() {
            let dispatch;

            switch (this.action) {
                case 'add':
                    dispatch = 'roles/addRole';
                    break;
                case 'edit':
                    dispatch = 'roles/updateRole';
                    break;
            }

            const params = {
                name: this.form.name,
                description: this.form.description,
                status: this.isRoleActive ? 'ACTIVE' : 'INACTIVE',
                permissions_raw: this.newActionKeys
            };

            this.form.loading = true;
            this.$store
                .dispatch(dispatch, {
                    id: this.$route.params.id,
                    config: {
                        params: params,
                        count: this.newModuleCount
                    }
                })
                .then((response) => {
                    this.form.loading = false;
                    this.$store.commit('permissions/SET_USER_ACTION_KEYS', this.newActionKeys);
                    this.$store.commit('permissions/SET_MODULE_COUNT', this.newModuleCount);
                    this.notification({ type: 'success', title: 'User Role', message: response.message });

                    if (this.$route.params.id) {
                        this.action = 'view';
                        this.$router.push(`/user-access/roles/view/${this.$route.params.id}`);
                    } else {
                        this.$router.push({ name: 'user-access', hash: '#roles' });
                    }
                })
                .catch(() => {
                    this.form.loading = false;
                });
        },
        setNewActionKeys(value) {
            this.newActionKeys = value;
        },
        setNewModuleCount(value) {
            this.newModuleCount = value;
        }
    }
};
</script>

<style lang="scss" scoped>
.status {
    border-radius: 4px;
}
</style>
